<template>
  <div class="pageWarp">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <!-- 日期、月份筛选区 -->
    <div class="filter_box boxs flex_h_hL_vC">
      <div class="left_picker boxs flex_h ite-c">
        <el-date-picker
                v-model="dateValue"
                type="month"
                placeholder="选择年月日"
                :clearable="false"
                @change="onDateChange"
        >
        </el-date-picker>
      </div>
    </div>

    <!-- 筛选框 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-input
                  v-model="searchForm.params.orderId"
                  placeholder="请输入订单号"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.userName"
                  placeholder="请输入用户姓名"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.userOpencardNumber"
                  placeholder="请输入开户号码"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

      </template>
    </sr-filter>

    <div class="summary_area boxs flex_h">
      <!-- 左边统计 -->
      <div class="left_simple_block summary_block boxs flex_h_hC_vC">
        <span class="clamp_1">共查询到 {{tableData.length}} 笔</span>
      </div>

      <div class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>本月应收代收款金额</span>
          <span>共&nbsp;<small>{{stat.dueCount}}</small>单</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.dueAmount | centsToYuan}}</span> 元
        </div>
      </div>

      <div class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>实收代收款金额</span>
          <span>共&nbsp;<small>{{stat.actualCount}}</small>单</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.actualAmount | centsToYuan}}</span> 元
        </div>
      </div>

      <div class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>核对成功（笔）</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT greenT">{{stat.successCount}}</span>
        </div>
      </div>

      <div class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>核对失败（笔）</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT orangeT">{{stat.failureCount}}</span>
        </div>
      </div>
    </div>


    <!-- 表格 -->
    <div class="botTable boxs tableTheadGray">
      <div class="tableTop">
        <span class="top_le">核对结果</span>

        <div class="btnGroup">
          <button v-if="confirmVisible" class="butStyle pinkBtn exportBtn" @click="editVoucher">
            <span>确认收款</span>
          </button>

          <button v-if="checkVisible" style="margin-left: 20px" class="butStyle pinkBtn exportBtn" @click="showVoucher">
            <span>查看收款单</span>
          </button>

          <button v-if="checkVisible" style="margin-left: 20px" class="butStyle pinkBtn exportBtn"
                  @click="tableExportAll">
            <span>批量解冻</span>
          </button>
        </div>
      </div>
      <el-table :data="tableData"
                size="small"
                style="width: 100%;"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
      >
        <el-table-column label="订单号" prop="orderId" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="blueT">{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户" prop="userName" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="开户号码" prop="userOpencardNumber" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="本月应收代收款金额（元）" prop="" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orangeT">{{scope.row.dueIncomeAt | centsToYuan}}</span>
          </template>
        </el-table-column>
        <el-table-column label="缴费状态" prop="recStatus" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="getRecStatusClass(scope.row.recStatus.value)">{{scope.row.recStatus.text}}</span>
          </template>
        </el-table-column>
        <el-table-column label="应收代收期数" prop="" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.periods}}/{{scope.row.totalPeriods}}
          </template>
        </el-table-column>
        <el-table-column label="本月实收代收款金额（元）" prop="actualAmount" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orangeT">{{scope.row.actualAmount | centsToYuan}}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收代收期数" prop="actualIncomeAt" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.recResult == 200">{{scope.row.periods}}/{{scope.row.totalPeriods}}</span>
          </template>
        </el-table-column>
        <el-table-column label="核对结果" prop="" min-width="12" header-align="center" align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="getRecResultClass(scope.row.recResult.value)">{{scope.row.recResult.text}}</span>
          </template>
        </el-table-column>

      </el-table>
      <div class="pageBox boxs">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="收款单" :visible.sync="dialogFormVisible" :modal="false" width="414px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="receiptNo" label="收款单据号：" :label-width="formLabelWidth">
          <el-input v-if="editForm" v-model="form.receiptNo" prop="receiptNo" autocomplete="off"></el-input>
          <span v-else>{{voucher.receiptNo}}</span>
        </el-form-item>
        <el-form-item label="收款日期：" :label-width="formLabelWidth">
          <el-date-picker
                  v-if="editForm"
                  v-model="receiptDateValue"
                  type="date"
                  placeholder="选择日期">
          </el-date-picker>
          <span v-else>{{doFormatDate(voucher.receiptDate, 'yyyy-MM-dd')}}</span>
        </el-form-item>
        <el-form-item prop="payerName" label="付款方名称：" :label-width="formLabelWidth">
          <el-input v-if="editForm" v-model="form.payerName" autocomplete="off"></el-input>
          <span v-else>{{voucher.payerName}}</span>
        </el-form-item>
        <el-form-item prop="amount" label="收款金额：" :label-width="formLabelWidth">
          <el-input v-if="editForm" v-model.number="form.amount" autocomplete="off"></el-input>
          <span v-else>{{voucher.amount | centsToYuan}}</span>
        </el-form-item>
        <el-form-item prop="payeeAccountNum" label="收款账户：" :label-width="formLabelWidth">
          <el-input v-if="editForm" v-model="form.payeeAccountNum" autocomplete="off"></el-input>
          <span v-else>{{voucher.payeeAccountNum.substr(0,3) + '******' + voucher.payeeAccountNum.substr(voucher.payeeAccountNum.length - 3)}}</span>
        </el-form-item>
        <el-form-item prop="note" label="摘要：" :label-width="formLabelWidth">
          <el-input v-if="editForm" v-model="form.note" autocomplete="off"></el-input>
          <span v-else>{{voucher.note}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button v-if="editForm" type="primary" @click="submitVoucherForm">确 定</el-button>
        <el-button v-if="!editForm" type="primary" @click="modifyForm">修 改</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';
  import {formatDate} from '@/utils/dateFormatter';
  import {centsToYuan} from '@/utils/unitConverter';
  import {getListAPI, getStatAPI, getVoucherAPI, addVoucherAPI, checkStatusAPI} from '@/api/Check/checkManage';
  import {objectToQueryString} from '@/utils/commonUtils.js';

  const status = {
    '-1': {text: '申请中', cls: 'grayT'},
    '0': {text: '待核销', cls: 'orangeT'},
    '1': {text: '未支付', cls: 'grayT'},
    '2': {text: '已支付', cls: 'lightGT'},
  }

  const recResult = {
    '200': 'lightGT'
  }

  const recStatus = {
    '1': 'lightGT'
  }


  //获取当前日期
  let getCurrDay = function () {
    let date = new Date();
    return formatDate(date, 'yyyyMM');
  }

  // 搜索表格的条件
  const searchConst = {
    current: 1, //当前页码
    size: 10, //每页条数
    params: {
      billMonth: getCurrDay(), //日期
      orderId: null,
      userName: null,
      userOpencardNumber: null
    },
  }

  export default {
    data() {
      return {
        rules: {
          receiptNo: [{required: true, message: '请输入收款单据号', trigger: 'blur'}],
          payerName: [{required: true, message: '请输入付款方名称', trigger: 'blur'}],
          payeeAccountNum: [{required: true, message: '请输入收款方账号', trigger: 'blur'}],
          amount: [{
            type: 'number', required: true, trigger: 'blur', validator: (rule, value, callback) => {
              if (value == undefined || value == '' || value == null) {
                callback(new Error("请输入金额"))
              } else if (value <= 0) {
                callback(new Error("金额必须大于0"))
              } else {
                callback();
              }
            }
          }],
          note: [{required: false, message: '请选择会员类型', trigger: 'blur'}],
        },
        editForm: true,
        checkForm: false,
        confirmVisible: true,
        checkVisible: true,
        dialogFormVisible: false,
        form: {
          id: '',
          receiptNo: '',
          receiptDate: '',
          payerName: '',
          payeeAccountNum: '',
          amount: '',
          note: '',
        },
        formLabelWidth: '120px',
        dateValue: new Date(),
        //标题
        topTitle: {
          title: '应收款与实收款核对',
          subTit: ''
        },

        // 筛选数据-日期
        filterData: [],

        // 是否隐藏页面顶部提示信息
        hideTopYellowTips: false,

        // 表格搜索条件
        searchForm: this.initSearchParams(),
        // 终端归属
        terminalOwnershipOptions: [],
        // 垫资方id
        advanceMoneyPlatformOptions: [],
        // 垫资状态
        statusOptions: [
          {key: 0, label: '待核销'},
          {key: 1, label: '未支付'},
          {key: 2, label: '已支付'},
        ],
        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,
        // 日期时间选择器
        timePickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },

        stat: {},

        voucher: null,

        receiptDateValue: new Date()
      }
    },
    computed: {},
    components: {
      TitleBox,
      SrFilter,
    },
    created() {
      this.getFilterData()
      this.loadList()
      this.getStat()
      this.initSearchParams()
      this.getVoucher()
      this.getCheckStatus()
    },
    methods: {
      async getCheckStatus() {
        const data = await checkStatusAPI(this.searchForm.params.billMonth)
        if (data && data == 'true') {
          this.confirmVisible = true
        }
      },
      modifyForm() {
        this.form = this.$deepClone(this.voucher)
        this.form.amount = centsToYuan(this.form.amount)
        this.receiptDateValue = new Date(this.voucher.receiptDate)
        this.editForm = true
      },
      doFormatDate(date, format) {
        return formatDate(date, format)
      },
      showVoucher() {
        this.editForm = false;
        this.dialogFormVisible = true
      },
      editVoucher() {
        this.editForm = true;
        this.dialogFormVisible = true
      },
      async getVoucher() {
        const result = await getVoucherAPI(this.searchForm.params.billMonth)
        if (result.data) {
          this.voucher = result.data
          this.voucher.receiptDate = new Date(result.data.receiptDate)
          this.checkVisible = true
          this.confirmVisible = false
        } else {
          this.checkVisible = false
          this.confirmVisible = true
        }
      },
      async submitVoucherForm() {

        let s = true
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let p = this.$deepClone(this.form)
            p.billMonth = this.searchForm.params.billMonth
            p.receiptType = 1
            p.receiptDate = this.doFormatDate(this.receiptDateValue, 'yyyyMMdd')
            p.amount = p.amount * 100
            const {result} = await addVoucherAPI(p)
            this.$message.success('收款单录入成功')
            this.dialogFormVisible = false
            this.getVoucher();
          }
        });
      },
      initSearchParams() {
        return this.$deepClone(searchConst);
      },
      getStatusText(val) {
        return status[val] || {text: '未知', cls: 'grayT'}
      },
      getRecResultClass(val) {
        return recResult[val] || 'orangeT'
      },
      getRecStatusClass(val) {
        return recStatus[val] || 'orangeT'
      },
      onDateChange(value) {
        if (!value) {
          this.searchForm.params.billMonth = null
        }
        this.searchForm.params.billMonth = this.doFormatDate(new Date(value), 'yyyyMM')
        this.handleSearch()
        this.getVoucher()
      },
      onStatusChange(value) {
        this.searchForm.params.status = value
        if (value == null || value == 'undefined' || value === '') {
          console.log(this.searchForm.params.status);
          this.searchForm.params.status = null
        }
        this.handleSearch()
      },
      tableExportAll() {
        const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}`;
        window.open(url, '_blank');
      },
      tableExport() {
        const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
        window.open(url, '_blank');
      },
      formatDefault: function (date) {
        return formatDate(date, 'yyyyMMdd');
      },

      getFilterData() {
        this.filterData = [
          {month: '5月', day: '25', dayOfTheWeek: '星期一', showIcon: '0'},
          {month: '5月', day: '24', dayOfTheWeek: '星期日', showIcon: '1'},
          {month: '5月', day: '23', dayOfTheWeek: '星期六', showIcon: '0'},
          {month: '5月', day: '22', dayOfTheWeek: '星期五', showIcon: '0'},
          {month: '5月', day: '21', dayOfTheWeek: '星期四', showIcon: '0'},
          {month: '5月', day: '20', dayOfTheWeek: '星期三', showIcon: '0'},
          {month: '5月', day: '19', dayOfTheWeek: '星期二', showIcon: '0'},
          {month: '5月', day: '18', dayOfTheWeek: '星期一', showIcon: '1'},
          {month: '5月', day: '17', dayOfTheWeek: '星期日', showIcon: '0'},
          {month: '5月', day: '16', dayOfTheWeek: '星期六', showIcon: '0'},
          {month: '5月', day: '15', dayOfTheWeek: '星期五', showIcon: '0'},
          {month: '5月', day: '14', dayOfTheWeek: '星期四', showIcon: '0'},
          {month: '5月', day: '13', dayOfTheWeek: '星期三', showIcon: '0'},
          {month: '5月', day: '12', dayOfTheWeek: '星期二', showIcon: '0'},
          {month: '5月', day: '11', dayOfTheWeek: '星期一', showIcon: '0'},
          {month: '5月', day: '10', dayOfTheWeek: '星期日', showIcon: '0'},
        ]
      },

      async getStat() {
        const {data} = await getStatAPI(this.searchForm.params)
        this.stat = data
      },

      // 获取表格数据
      async loadList() {
        const {data} = await getListAPI(this.searchForm)
        this.tableData = data.records
        this.total = data.total
      },

      // 列表过滤查询
      handleSearch() {
        this.loadList()
        this.getStat()
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        // this.searchForm.date = getCurrDay();
        this.dateValue = new Date()
        this.searchForm = this.initSearchParams()
        console.log(this.searchForm)
        // 获取表格数据
        this.handleSearch()
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.loadList()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.loadList()
      },


      // 跳转到详情页
      goDetailPage(scope) {
        this.$router.push({
          path: '/tbs/fundManage/reducedFeeDetail',
          query: {
            orderId: scope.row.orderId
          }
        })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .greenT {
    color: #2DBAA5 !important;
  }

  .lightGT {
    color: #76C819 !important;
  }

  .orangeT {
    color: #FA6241 !important;
  }

  .grayT {
    color: #B7B2AF !important;
  }

  .blueT {
    color: #3289FF !important;
  }


  .pageWarp {
    height: calc(100vh - 88px);
  }

  // 黄色提示栏
  .pageWarp .yellow_tips_box {
    margin-top: 0px;
    width: 100%;
    min-height: 28px;
    padding: 6px 9px 6px 12px;
    background: #FFFAEB;
    border: 1px solid #FFC400;
    transition: all 0.3s ease;
  }

  .pageWarp .yellow_tips_box.hide {
    display: none;
    transition: all 0.3s ease;
  }

  .yellow_tips_box .info {
    width: calc(100% - 9.71px - 5px);
    line-height: 16px;
    color: #FFC400;
    font-size: 12px;
    margin-right: 5px;
  }

  .yellow_tips_box .icon_close_yellow {
    width: 9.71px;
    height: 9.71px;
  }


  // 日期、月份筛选区
  .pageWarp .filter_box {
    margin: 5px 0;
    width: 100%;
    height: 124px;
    padding: 30px 0;
    box-sizing: border-box;
    background: #ffffff;
  }

  .filter_box .left_picker {
    width: 205px;
    height: 100%;
    padding: 0 20px 0 12px;
    box-sizing: border-box;
    background: #ffffff;
    border-right: 1px solid #F8F8F8;
  }

  .filter_box ul.right_scroll {
    width: calc(100% - 205px);
    height: 100%;
    padding: 0 12px 0 16px;
    box-sizing: border-box;
    background: #ffffff;
  }

  .filter_box ul.right_scroll li {
    min-width: 46px;
    height: 100%;
    background: #bfd8f8;
  }

  .filter_box ul.right_scroll li:first-child {
    margin-left: 16px;
  }

  .filter_box ul.right_scroll li + li {
    margin-left: 40px;
  }

  .filter_box ul.right_scroll li .top {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #7F7F7F;
  }

  .filter_box ul.right_scroll li .circle_box {
    width: 46px;
    height: 46px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    border-radius: 50%;
    position: relative;
    background: #ffffff;
    color: #C5C5C5;
  }

  .filter_box ul.right_scroll li .circle_box.greenBg {
    background: #2DBAA5;
    color: #ffffff;
  }

  .filter_box ul.right_scroll li .circle_box.grayBg {
    background: #FAFAFA;
    color: #333333;
  }

  .filter_box ul.right_scroll li .circle_box .mainT {
    font-size: 20px;
  }

  .filter_box ul.right_scroll li .circle_box .botT {
    font-size: 10px;
    margin-top: 0px;
  }

  .filter_box ul.right_scroll li .warnIcon {
    position: absolute;
    right: 0;
    bottom: 0;

    width: 16px;
    height: 16px;
    background: url('../../../../assets/images/enjoy/redWarnCircleIcon.png') no-repeat;
    background-size: 100% 100%;
  }


  // 筛选框
  .pageWarp .searchBox {
    margin-top: 0px;
  }


  // 总结
  .pageWarp .summary_area {
    flex-wrap: wrap;
  }

  .pageWarp .summary_block {
    margin-top: 12px;
    width: 207px;
    height: 72px;
    background: #fff;
    // border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 20px;
    font-size: 12px;
    color: #333333;
    white-space: nowrap;
    margin-right: 14px;
  }

  .pageWarp .summary_block .first_text {
    min-width: 160px;
    max-width: 100%;
    margin-bottom: 6px;
  }

  .pageWarp .summary_block .first_text small {
    color: #2DBAA5;
    margin-right: 3px;
  }

  .pageWarp .summary_block .second_text {
    // line-height: 16px;
    height: 20px;
  }

  .pageWarp .summary_block .second_text span.bigT {
    height: 20px;
    color: #FA6241;
    font-size: 20px;
    font-weight: normal;
    margin-right: 3px;
  }

  // 左边统计
  .pageWarp .summary_area .summary_block.left_simple_block {
    width: 141px;
    height: 72px;
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 0px;
    font-size: 12px;
    color: #333333;
    white-space: nowrap;
    margin-right: 14px;
  }


  // 表格
  .pageWarp .botTable {
    margin-top: 12px;
    width: 100%;
    // max-height: 408px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .exportBtn {
    padding: 5px;
    /*width: 72px;*/
    height: 30px;
    /*line-height: 30px;*/
    font-size: 13px;
    border-radius: 4px;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .disabledStyle {
    background-color: #fa414152
  }


</style>

